import { LottieRefCurrentProps } from "lottie-react";
import { ReactNode, useEffect, useRef, useState } from "react";

import {
  LottieContainer,
  LottieStyled,
  ValueHeader,
  ValueText,
} from "./Values.styled";

interface ValueContainerProps {
  icon: any;
  title: string;
  children?: ReactNode;
}

export const ValueContainer = ({
  icon,
  title,
  children,
}: ValueContainerProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const lottieRef = useRef<LottieRefCurrentProps>(null);
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!isInView && entry.isIntersecting) {
          lottieRef.current?.goToAndPlay(0);
          setIsInView(entry.isIntersecting);
        }
      },
      { root: null, threshold: 0.1 },
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    const currentRef = ref.current;

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [isInView]);

  const [isPlaying, setIsPlaying] = useState(false);

  const triggerAnimation = () => {
    if (lottieRef.current && !isPlaying) {
      lottieRef.current.goToAndPlay(0);
      setIsPlaying(true);
      setTimeout(
        () => setIsPlaying(false),
        (lottieRef.current.getDuration() ?? 0) * 1000,
      );
    }
  };

  return (
    <div ref={ref} onMouseEnter={triggerAnimation}>
      <LottieContainer>
        <LottieStyled
          lottieRef={lottieRef}
          animationData={icon}
          loop={false}
          autoplay={false}
        />
      </LottieContainer>
      <ValueHeader>{title}</ValueHeader>
      <ValueText>{children}</ValueText>
    </div>
  );
};
